import 'globals';

(function(PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        new LazyEmbed({
            elements: '[data-lazyembed="video"]',
            overlayText: _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.video.replace('{uri}', _AVENCY_BASE_pages.privacyPolicy),
            excludeElements: ':not([data-allow="true"])',
            includeElements: '[data-allow="true"]',
            onInit: function (wrapper) {
                const overlayText = wrapper.querySelector('.lazyembed__text');
                const overlayIcon = wrapper.querySelector('.lazyembed-icon');

                const showModal = () => {
                    wrapper.closest('.lazyembed').dataset.modalTarget = "true";

                    if (!window.viewport.md.up) {
                        $('#videoDsgvoModal').modal('show');
                    }
                };

                overlayText.addEventListener('click', showModal, {passive: true});
                if (overlayIcon) {
                    overlayIcon.addEventListener('click', showModal, {passive: true});
                }
            }
        });
        new LazyEmbed({
            elements: '[data-lazyembed="map"]',
            overlayText: _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.map.replace('{uri}', _AVENCY_BASE_pages.privacyPolicy)
        });

        const videoModal = document.querySelector('#videoDsgvoModal');

        if (videoModal) {
            const approveButtons = videoModal.querySelectorAll('[data-allow="true"]');
            const declineButton = videoModal.querySelector('[data-allow="false"]');

            if (approveButtons.length) {
                Array.from(approveButtons).forEach(function (buttonEl) {
                    buttonEl.addEventListener('click', function () {
                        const target = document.querySelector('.lazyembed[data-modal-target="true"]');

                        if (target) {
                            target.querySelector('[data-allow="true"]').click();
                        }
                        $('#videoDsgvoModal').modal('hide');
                    }, {passive: true});
                });
            }

            if (declineButton) {
                declineButton.addEventListener('click', function () {
                    $('#videoDsgvoModal').modal('hide');
                }, {passive: true});
            }

            $('#videoDsgvoModal').on('hide.bs.modal', function () {
                const target = document.querySelector('.lazyembed[data-modal-target="true"]');
                delete target.dataset.modalTarget;
            });
        }
    });
})(window.PageLoadedQueue);
